<script>
  //import AutoQi from "./AutoQi.svelte"
  import { auth, db } from "../../etc/firebase.js"
  import { currentUser } from "../../etc/store.js"
  //import GuaForm from "./GuaForm.svelte"
  //import GuaResult from "./GuaResult.svelte"
  //import { formData } from "../../etc/store.js"
  //import { daYanArray } from "./allNumbers.js"
  import { stickReduction, number2code } from "./helpers.js"
  //import Sha256 from "./sha256.js"

  // add Gua Result
  let guaNumbers = ""
  let guaCode = ""
  let qiGuaPerson = ""
  let cloudGuaResults = []

  function popUp(resutls) {
    var frog = window.open(
      "",
      "wildebeast",
      "width=300,height=300,scrollbars=1,resizable=1"
    )

    //var text = document.form.input.value

    var html = "<html><head></head><body>" + resutls + "</body></html>"

    //variable name of window must be included for all three of the following methods so that
    //javascript knows not to write the string to this window, but instead to the new window

    frog.document.open()
    frog.document.write(html)
    frog.document.close()
  }

  //   function addGuaResult() {
  //     const qiGuaDT = new Date().getTime()
  //     db.collection("guaSimResults").add({
  //       qiGuaDT,
  //       guaNumbers,
  //       guaCode,
  //       qiGuaPerson,
  //     })

  //     guaNumbers = ""
  //     guaCode = ""
  //   }

  // Listen for auth status change
  //   auth.onAuthStateChanged((user) => {
  //     if (user) {
  //       //console.log(user.email + " just logged in!")
  //       currentUser.email = user.email
  //       qiGuaPerson = user.email

  //       // get notes data from Firebase db
  //       db.collection("guaSimResults")
  //         .orderBy("qiGuaDT")
  //         .onSnapshot((data) => {
  //           console.log(data.docs)
  //           cloudGuaResults = data.docs
  //         })
  //     } else {
  //       currentUser.email = ""
  //       currentUser.loggedIn = false
  //       qiGuaPerson = ""
  //       console.log(currentUser.email + " just logged out!")
  //     }
  //   })

  let mergedSeed = ""
  let numStr = ""
  let simCount = 1
  let simResults = []

  /*********
   * The genGua algorithm is as the following:
   * 1, Create input string to hash using Sha256
   *    Date + QiGua User Name + Question + Yao# (1, 2, 3, 4, 5, 6) + Split# (1, 2, 3)
   * 2, Get the Hash Code, converting it to Integer
   * 3, Divide the hash_quotien = hash_in / timestamp_int
   * 4, Mode hash_quotien by base_range according to split# and remaining stick count
   *    (base_range: 29, 25, 23, 21, 19, 17)
   * 5, kick_index = hash_quotien + start_index (according to split# and remaining stick count)
   * 6, wait hash_quotien ms and get the next kick_index for total 6 yao * 3 splits = 18 times
   * 7, is the return value of genKick and the index to kick out.
   * *********/
  function genGua() {
    // numStr will be a 6-char long string consists of [6|7|8|9] and send it to GuaResult
    numStr = "" // initialize to empty string before building gua

    // mergedSeed will be differ by yao_count and split_count
    //mergedSeed = $formData.name + $formData.question

    // In simulation, I will hard code the user name and question.
    mergedSeed =
      "我是誠心誠意的任何人，藉著大易筮占的靈驗，今天想誠心誠意地問任何問題，有關這個問題的吉凶得失，悔吝憂虞？還請麻煩告訴我，謝謝。"
    numStr = stickReduction(mergedSeed)
    return numStr
  }

  function handleSimulation() {
    for (var i = 0; i < simCount; i++) {
      //console.log("QiGuaSim run: " + (i + 1))
      guaNumbers = genGua()
      guaCode = number2code(guaNumbers)
      simResults.push(guaNumbers)
      //addGuaResult()
    }
    //console.log(simResults.toString())
    popUp(simResults.toString())
    simResults = []
  }
</script>

<main>
  <a href="/sandbox">Return to Sandbox</a>

  <h5>Auto Qi Gua Simulation</h5>
  <p>
    Specify how many time you wish the simulation to run. For guest visitor, the
    maximun simulation count is 10.
  </p>
  <div class="sim-control">
    <form class="content" on:submit|preventDefault={handleSimulation}>
      <input type="text" bind:value={simCount} placeholder="" />
      <button class="btn">Start Simulation</button>
    </form>
  </div>
  <!-- <d class="card"><AutoQi /></d> -->
</main>

<style>
  .sim {
  }
</style>
